import React from "react";

const SkeletonCard = () => {
  return (
    <div className="w-[60vw] md:w-[25vw] lg:w-[20vw] p-4 animate-pulse bg-white">
      <div className="w-full h-32 bg-gray-300"></div>
      <div className="w-3/4 h-5 mt-4 bg-gray-300"></div>
      <div className="w-full h-4 mt-2 bg-gray-300"></div>
      <div className="w-5/6 h-4 mt-2 bg-gray-300"></div>
      <div className="w-1/3 h-10 mt-4 bg-gray-300"></div>
    </div>
  );
};

export default SkeletonCard;
